var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-main"},[_c('PageTop',{attrs:{"page":"login"}}),(_vm.from === 'student')?_c('StudentLoginForm'):_vm._e(),(_vm.from === 'teacher')?_c('TeacherLoginForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }